module.exports = __webpack_public_path__ + "static/media/rightCellBackground.cd8065b2.png";